import { render, staticRenderFns } from "./FailedPayment.vue?vue&type=template&id=590a05f8&scoped=true"
import script from "./FailedPayment.vue?vue&type=script&lang=js"
export * from "./FailedPayment.vue?vue&type=script&lang=js"
import style0 from "./FailedPayment.vue?vue&type=style&index=0&id=590a05f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a05f8",
  null
  
)

export default component.exports